var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{attrs:{"role":"presentation"}},[_c('a',_vm._g(_vm._b({staticClass:"dropdown-item",attrs:{"role":"menuitem"},on:{"click":_setup.closeDropdown}},'a',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }